import React, { useRef } from "react"
import { DataGrid, Button, Template } from "devextreme-react"
import {
  Editing,
  Column,
  Lookup,
  StateStoring,
  ColumnChooser,
  ColumnFixing,
  Pager,
  FilterPanel,
  Grouping,
  GroupPanel,
  HeaderFilter,
  SearchPanel,
  FilterRow,
  Scrolling,
} from "devextreme-react/data-grid"
import DataSource from "devextreme/data/data_source"
import { FaCogs } from "react-icons/fa"

import {
  sageColumnDataStore,
  applicationDataStore,
} from "../../shared/CoreStore"
import { hasAccessTo } from "../../../authentication"
import { PageTitle } from "../../shared/StyledComponents"

const sageColumnDataSource = new DataSource({ store: sageColumnDataStore })

const Columns = () => {
  const sageColumnsGrid = useRef(null)

  const refreshMessageGridClickHandler = () => {
    sageColumnsGrid.current.instance.refresh(true)
  }

  const toolbarPreparingHandler = e => {
    e.toolbarOptions.items.unshift({
      location: "before",
      template: "refreshGrid",
    })
  }
  return (
    <>
      <PageTitle icon={FaCogs}>Sage Columns</PageTitle>
      <DataGrid
        allowColumnReordering={true}
        allowColumnResizing={true}
        columnAutoWidth={true}
        columnResizingMode="widget"
        dataSource={sageColumnDataSource}
        hoverStateEnabled={true}
        ref={sageColumnsGrid}
        rowAlternationEnabled={true}
        showBorders={true}
        visible={hasAccessTo("c.sage.column.r")}
        onToolbarPreparing={toolbarPreparingHandler}
      >
        <Column allowEditing={false} dataField="id" dataType="number" />
        <Column
          caption="Application"
          dataField="applicationId"
          dataType="number"
        >
          <Lookup
            dataSource={{
              store: applicationDataStore,
              map: item => {
                return { ...item, id: item.id.toString() }
              },
            }}
            valueExpr="applicationId"
            displayExpr="title"
          />
        </Column>
        <Column dataField="moduleType" dataType="string" />
        <Column dataField="sageEdition" dataType="string">
          <Lookup dataSource={["sage_100", "sage_500", "sage_x3"]} />
        </Column>
        <Column dataField="dataField" dataType="string" />
        <Column dataField="caption" dataType="string" />
        <Column dataField="dataType" dataType="string">
          <Lookup
            dataSource={[
              "string",
              "number",
              "date",
              "boolean",
              "object",
              "datetime",
            ]}
          />
        </Column>
        <Column dataField="allowEditing" dataType="boolean" />
        <Column dataField="visible" dataType="boolean" />
        <Column dataField="level" dataType="string" />
        <Column dataField="aggregate" dataType="boolean" />
        <Column dataField="attributes" dataType="string" />
        <Column dataField="sequence" dataType="number" />
        <ColumnChooser
          allowSearch={true}
          enabled={true}
          height="400"
          mode="select"
        />
        <ColumnFixing enabled={true} />
        <Editing
          allowDeleting={hasAccessTo("c.sage.column.d")}
          allowUpdating={hasAccessTo("c.sage.column.u")}
          allowAdding={hasAccessTo("c.sage.column.c")}
          mode="cell"
          useIcons={true}
        />
        <FilterPanel visible={true} />
        <FilterRow visible={true} />
        <Grouping contextMenuEnabled={true} />
        <GroupPanel visible={true} />
        <HeaderFilter visible={true} />
        <Pager
          visible={true}
          allowedPageSizes={[10, 20, 50, 100]}
          showPageSizeSelector={true}
          showNavigationButtons={true}
          showInfo={true}
        />
        <Scrolling showScrollbar="always" />
        <SearchPanel visible={true} />
        <StateStoring
          enabled={true}
          type="localStorage"
          storageKey="profile-sage-columns"
        />
        <Template name="refreshGrid">
          <Button icon="refresh" onClick={refreshMessageGridClickHandler} />
        </Template>
      </DataGrid>
    </>
  )
}

export { Columns }
export default Columns
